<template>
  <div class="number-component">
    <input
      :style="aiInlineCss"
      type="text"
      v-if="editableComponent"
      :placeholder="componentPlaceholder"
      class="number-input"
      autocomplete="off"
      :class="styleClass"
      @blur="validateValue()"
      :value="getFormattedValue"
      @keyup="onInputChange($event)"
      @keydown="checkValidInput($event)"
      @input="handleInputValidation"
      @invalid="handleInputValidation"
      :required="requiredInput"
      :disabled="disabledInput"
      :name="elementName"
      :id="`input-${elementId}`"
      ref="formateNumberInputRef"
    />
    <span class="validation-error" v-if="isShowValidationError">{{
      validationError.error
    }}</span>
    <span
      class="validation-error"
      v-if="componentValidationError && componentValidationError.show"
      >{{ componentValidationError.error }}</span
    >
    <div
      class="number-component-view-wrap"
      v-show="!editableComponent"
      :class="{ 'align-to-end': isContentAlignedToEnd }"
    >
      {{ getFormattedValue }}
    </div>
  </div>
</template>

<script>
import { showInputInvalidCustomMessage } from '../../utils/helpers';
export default {
  name: 'NumberComponent',
  data() {
    return {
      currentNumberInputValue:
        this.passedNumberValue !== null ? this.passedNumberValue : '',
      isShowValidationError: false,
      componentValidationError: null,
      lastValue: null,
    };
  },
  props: {
    isAskAiUiModalVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    aiInlineCss: {
      type: String,
      required: false,
      default: '',
    },
    passedNumberValue: {
      type: Number | null,
      required: true,
      default: 0,
    },
    formatNumber: {
      type: Object,
      default: () => ({ thousandseparator: '.', decimalseparator: ',' }),
    },
    unit: {
      type: String,
      required: false,
      default: '',
    },
    steps: {
      type: Number,
      default: 1,
    },
    editableComponent: {
      type: Boolean,
      required: false,
      default: false,
    },
    componentPlaceholder: {
      type: String,
      required: false,
    },
    styleDetails: Object,
    styleClass: {
      type: String,
      default: '',
      required: false,
    },
    validationError: {
      type: Object,
      required: false,
      default: () => ({ show: false, error: '', value: null }),
    },
    preventFloatInputValue: {
      type: Boolean,
      default: false,
    },
    minimumDecimalValues: {
      type: Number,
      default: 3,
      required: false,
    },
    decimalValuesCount: {
      type: Number,
      default: 2,
      required: false,
    },
    disabledInput: {
      type: Boolean,
      default: false,
    },
    requiredInput: {
      type: Boolean,
      default: false,
    },
    minValue: {
      type: Number,
      required: false,
    },
    maxValue: {
      type: Number,
      required: false,
    },
    elementName: {
      type: String,
      required: false,
      default: 'number-input',
    },
    showAsFixedNumber: {
      type: Boolean,
      required: false,
      default: false,
    },
    isContentAlignedToEnd: {
      type: Boolean,
      required: false,
      default: false,
    },
    elementId: {
      type: String,
      required: false,
    },
    isCardElem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onInputChange(event) {
      // current input change value to store in original number abd remove replacer(thousandseparator,decimalseparator)
      let thousandseparator = this.getThousandSeparator();
      let decimalseparator = this.getDecimalSeparator();
      const charCode = event.keyCode;
      if ((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
        if (isNaN(Number(event.target.value))) {
          this.showNumberErrorMessage();
          event.target.value = 0;
          this.currentNumberInputValue = 0;
          return false;
        } else {
          event.target.value = this.getFormattedValueFunction(
            event.target.value
          );
          return true;
        }
      }
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 96 || charCode > 105) &&
        charCode !== 38 &&
        charCode !== 40 &&
        !this.validKeyBoardInputs.includes(charCode)
      ) {
        event.preventDefault();
        return false;
      }
      // else if (
      //   this.currentNumberInputValue.toString().indexOf('.') == -1 &&
      //   (charCode == 190 || charCode == 110 || charCode == 188) &&
      //   !this.preventFloatInputValue
      // ) {
      //   // this.currentNumberInputValue =
      //   //   String(this.currentNumberInputValue) + '.';
      //   this.$emit('onNumberInputChange', Number(this.currentNumberInputValue));
      // }
      else {
        const valueAfterDecimal = this.currentNumberInputValue
          .toString()
          .split('.')[1]
          ?.toString();
        const decimalCount = event.target.value.split(
          this.getDecimalSeparator()
        )[1]?.length;
        if (
          this.currentNumberInputValue.toString().indexOf('.') != -1 &&
          valueAfterDecimal.length > 1 &&
          event.target.value.length > 1
        ) {
          if (
            valueAfterDecimal.indexOf(0) != -1 &&
            (charCode == 8 || charCode == 46)
          ) {
            this.currentNumberInputValue = event.target.value
              .replaceAll(thousandseparator, '')
              .replace(decimalseparator, '.');
          } else {
            const numberedValue = Number(
              event.target.value
                .replaceAll(thousandseparator, '')
                .replace(decimalseparator, '.')
            );
            if (isNaN(numberedValue)) {
              this.showNumberErrorMessage();
              event.target.value = 0;
              this.currentNumberInputValue = 0;
              return false;
            }
            this.currentNumberInputValue =
              Math.round(
                (numberedValue + Number.EPSILON) *
                  Math.pow(10, this.decimalValuesCount)
              ) / Math.pow(10, this.decimalValuesCount);

            if (
              decimalCount !== undefined &&
              decimalCount < this.decimalValuesCount
            ) {
              this.currentNumberInputValue =
                this.currentNumberInputValue.toFixed(decimalCount);
            } else {
              this.currentNumberInputValue =
                this.currentNumberInputValue.toFixed(this.decimalValuesCount);
            }
          }
        } else {
          this.currentNumberInputValue = event.target.value
            .replaceAll(thousandseparator, '')
            .replace(decimalseparator, '.');
          if (
            decimalCount !== undefined &&
            decimalCount > this.decimalValuesCount
          ) {
            const numberedValue = Number(this.currentNumberInputValue).toFixed(
              this.decimalValuesCount
            );
            if (isNaN(numberedValue)) {
              this.showNumberErrorMessage();
              event.target.value = 0;
              this.currentNumberInputValue = 0;
              return false;
            }
            this.currentNumberInputValue = numberedValue;
          }
        }

        const oldCursorPosition = event.target.selectionStart;
        const thousandSeparatorCount =
          event.target.value.split(this.getThousandSeparator()).length - 1;
        event.target.value = this.getFormattedValueFunction(
          this.currentNumberInputValue
        );
        //emit the value to original props value change
        const updatedThousandSeparatorCount =
          event.target.value.split(this.getThousandSeparator()).length - 1;
        if (
          this.currentNumberInputValue === '' ||
          this.currentNumberInputValue === null
        ) {
          this.$emit('onNumberInputChange', null);
        } else {
          this.$emit(
            'onNumberInputChange',
            Number(this.currentNumberInputValue)
          );
        }
        //if we add any digit
        if (thousandSeparatorCount !== updatedThousandSeparatorCount) {
          if (charCode === 8) {
            //when you remove the thousand separator
            if (this.lastValue[oldCursorPosition] === thousandseparator) {
              event.target.setSelectionRange(
                oldCursorPosition,
                oldCursorPosition
              );
            } // when you remove the decimal separator
            else if (this.lastValue[oldCursorPosition] === decimalseparator) {
              const splitedValue = this.lastValue.split(
                this.getDecimalSeparator()
              )[0];
              const thousandseparatorBefore =
                splitedValue.split(thousandseparator).length - 1;
              const thousandseparatorAfter =
                event.target.value
                  .substring(0, splitedValue.length)
                  .split(thousandseparator).length - 1;
              event.target.setSelectionRange(
                oldCursorPosition +
                  thousandseparatorAfter -
                  thousandseparatorBefore,
                oldCursorPosition +
                  thousandseparatorAfter -
                  thousandseparatorBefore
              );
            } else {
              event.target.setSelectionRange(
                oldCursorPosition - 1,
                oldCursorPosition - 1
              );
            }
          } else {
            event.target.setSelectionRange(
              oldCursorPosition + 1,
              oldCursorPosition + 1
            );
          }
        } else if (oldCursorPosition !== event.target.selectionStart) {
          event.target.setSelectionRange(oldCursorPosition, oldCursorPosition);
        }
        this.lastValue = event.target.value;
        return true;
      }
    },
    checkValidInput(event) {
      if (
        event.target.selectionStart == event.target.selectionEnd &&
        this.currentNumberInputValue?.length >= 38 &&
        /[0-9]/.test(event.key)
      ) {
        event.preventDefault();
      }

      if (
        this.isAskAiUiModalVisible ||
        (event.shiftKey == 1 && !this.arrowKeyCodes.includes(event.keyCode))
      ) {
        event.preventDefault();
      }
      const charCode = event.keyCode;
      const stringifiedValue = this.currentNumberInputValue.toString();
      if (
        stringifiedValue.indexOf('.') > -1 ||
        stringifiedValue.length === 0 ||
        this.preventFloatInputValue
      ) {
        if (
          charCode == 190 ||
          charCode == 110 ||
          charCode == 188 ||
          charCode == 222
        ) {
          event.preventDefault();
        }
      }
      if (
        event.target.selectionStart !== 0 &&
        (charCode == 189 || charCode == 109)
      ) {
        event.preventDefault();
      }

      if (charCode == 38) {
        this.currentNumberInputValue = (
          Number(this.currentNumberInputValue) + Number(this.steps)
        ).toFixed(this.decimalValuesCount);
      }

      if (charCode == 40) {
        this.currentNumberInputValue = (
          Number(this.currentNumberInputValue) - Number(this.steps)
        ).toFixed(this.decimalValuesCount);
      }

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 96 || charCode > 105) &&
        !this.validKeyBoardInputs.includes(charCode)
      ) {
        if (
          (event.ctrlKey || event.metaKey) &&
          this.shortcutKeyCodes.includes(event.keyCode)
        ) {
          return true;
        }
        event.preventDefault();
        return false;
      } else {
        return true;
      }
    },
    validateValue() {
      if (
        this.validationError.value &&
        this.validationError.value >= this.currentNumberInputValue
      )
        this.isShowValidationError = true;
      else if (this.minValue && this.minValue > this.currentNumberInputValue) {
        this.componentValidationError = {
          show: true,
          error: 'Mindestwert ' + this.minValue,
          value: null,
        };
        this.$emit('toggleValidationError', true);
      } else if (
        this.maxValue &&
        this.maxValue < this.currentNumberInputValue
      ) {
        this.componentValidationError = {
          show: true,
          error: 'Höchster Wert ' + this.maxValue,
          value: null,
        };
        this.$emit('toggleValidationError', true);
      } else {
        this.isShowValidationError = false;
        if (
          this.currentNumberInputValue !== '' &&
          this.currentNumberInputValue !== null
        ) {
          this.currentNumberInputValue = Number(
            this.currentNumberInputValue
          ).toFixed(this.decimalValuesCount);
        }
        this.$emit('toggleValidationError', false);
        this.componentValidationError = { show: false, error: '', value: null };
        return true;
      }
    },
    getFormattedValueFunction(newInputValue) {
      if (newInputValue !== null) {
        let numberParts = newInputValue.toString().split('.');
        numberParts[0] = numberParts[0].replace(
          /\B(?=(\d{3})+(?!\d))/g,
          this.getThousandSeparator()
        );
        return numberParts.join(this.getDecimalSeparator());
      }
      return '';
    },

    setFormattedNumber() {
      if (
        !isNaN(this.currentNumberInputValue) &&
        typeof this.currentNumberInputValue === 'number'
      ) {
        this.currentNumberInputValue = this.currentNumberInputValue.toFixed(
          this.decimalValuesCount
        );
      } else if (this.isCardElem && this.currentNumberInputValue === '0') {
        this.currentNumberInputValue = Number(
          this.currentNumberInputValue
        ).toFixed(this.decimalValuesCount);
      }
    },
    getDecimalSeparator() {
      if (
        (this.formatNumber.decimalseparator === '' ||
          this.formatNumber.decimalseparator === '-') &&
        this.formatNumber.thousandseparator === ','
      ) {
        return '.';
      } else if (
        !this.formatNumber.decimalseparator ||
        this.formatNumber.decimalseparator === '-'
      ) {
        return ',';
      } else {
        return this.formatNumber.decimalseparator;
      }
    },
    getThousandSeparator() {
      if (
        (this.formatNumber.thousandseparator === '' ||
          this.formatNumber.thousandseparator === '-') &&
        this.formatNumber.decimalseparator === '.'
      ) {
        return ',';
      }
      if (
        !this.formatNumber.thousandseparator ||
        this.formatNumber.thousandseparator === '-'
      ) {
        return '.';
      } else {
        return this.formatNumber.thousandseparator;
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    showNumberErrorMessage() {
      this.showToaster('NUR ZAHLEN SIND ERLAUBT', 'Fehlerhaft !', 'danger');
    },
    handleInputValidation(event) {
      showInputInvalidCustomMessage(event);
    },
  },
  computed: {
    validKeyBoardInputs() {
      let separatorKeycode = {
        ',': 188,
        '.': 190,
        "'": 222,
      };
      return [
        110,
        46,
        37,
        39,
        189,
        109,
        separatorKeycode[this.getThousandSeparator()],
        separatorKeycode[this.getDecimalSeparator()],
      ];
    },
    arrowKeyCodes() {
      return [37, 38, 39, 40, 98, 100, 104, 102];
    },
    shortcutKeyCodes() {
      return [65, 67, 86, 82, 88, 90];
    },
    getFormattedValue() {
      return this.getFormattedValueFunction(this.currentNumberInputValue);
    },
    getNewFormattedValue() {
      let num = parseFloat(this.currentNumberInputValue);
      if (!num) return '';
      return num
        .toLocaleString('de-DE')
        .replace('.', this.getThousandSeparator())
        .replace(',', this.getDecimalSeparator());
    },
  },
  created() {
    this.setFormattedNumber();
  },
  watch: {
    decimalValuesCount() {
      this.currentNumberInputValue = this.passedNumberValue.toFixed(
        this.decimalValuesCount
      );
    },
    passedNumberValue(newValue) {
      if (!isNaN(newValue)) {
        if (this.showAsFixedNumber) {
          this.currentNumberInputValue = newValue;
          this.setFormattedNumber();
        }
      }
    },
  },
};
</script>

<style scoped>
.number-input {
  display: block;
  width: 100%;
  height: 40px;
  padding: 4px 15px;
  box-sizing: border-box;
}
.number-unit {
  width: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 14px;
}
.number-component-view-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-right: 10px;
  font-family: 'AktivGroteskMedium';
}
.validation-error {
  color: red;
}
.number-component .align-to-end {
  display: flex;
  justify-content: flex-end;
}
</style>
